import styled, { css, keyframes } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
// styled-components.
// -----------------------------------------------------------------------------
// Animations.
const spinner = keyframes `
  to { transform: rotate(360deg); }
`;
// styled-components
export const IconRoot = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* this is the CSS class that fontawesome sets when we set the prop 'spin' to 'true'. */
  .fa-spinner-third {
    animation: ${spinner} 1s linear infinite;
  }

  ${({ size = 'l' }) => {
    return css `
      svg {
        /* Fixed */
        transition: 0.3s;
        height: auto;
        width: ${getSpace(size)};

        /* Misc */
        transition: 0.3s;
      }
    `;
}}
`;
//# sourceMappingURL=Icon.styled.js.map